'use client'
import { useMemo, type FC } from 'react'
import styled from 'styled-components'
import { SectionContents } from '@/components/project/contents/SectionContents'
import { vw, mq } from '@/styles'
import type { TypeCmsContentsBlock } from '@/schema'

type Props = {
  data: TypeCmsContentsBlock[]
}

export const getSections = data => data.map((item) => {
  const { id, contentType } = item
  return <SectionContents key={id} section={item} isMulticolumn={contentType === 'multi_columns'} isThreeColumn={ contentType=== 'three_columns'}/>
})

export const MainContents:FC<Props> = ({ data = [] }) => {
  const Sections = useMemo(() => getSections(data), [data])
  return (
    <Main>
      {Sections}
    </Main>
  )
}

const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
	margin-top: 40px;
  margin-bottom: ${vw(50, 'mobile')};
  width: 100vw;
  
  ${mq.greaterThan('tablet')} {
    margin-bottom: ${vw(150, 'desktop')};
  }
`
